
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.997","height":"23.997","viewBox":"0 0 23.997 23.997"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.005 5.98c-3.332-.33-6.685-.5-10.027-.5a59.31 59.31 0 00-5.945.3l-2.041.2","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.508 4.957l.219-1.306c.16-.948.281-1.656 1.965-1.656h2.616c1.683 0 1.812.748 1.962 1.666l.219 1.3","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".34"}}),_c('path',{attrs:{"d":"M18.86 9.177l-.651 10.043c-.11 1.566-.2 2.783-3 2.783H8.783c-2.795 0-2.885-1.217-3-2.783L5.136 9.177","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.333 16.498h3.321M9.505 12.498h4.987","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".34"}})])
          )
        }
      }
    